import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Modal, Row, Toast, Button, OverlayTrigger, Tooltip} from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { useLocation, useNavigate } from 'react-router-dom'
import 'recupero-comunes/dist/index.css'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import {validationSchemas} from '../../../common/validation-Schemas-extrajudicial'
import Acciones from './aciones'
import Backdrop from '@material-ui/core/Backdrop';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialIcon from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import { makeStyles } from '@material-ui/core/styles';
import ContactoTerceroModal from './modalContactoTercero'
import { MdAccountBox } from "react-icons/md";
import { GiLetterBomb } from "react-icons/gi";
import { BsFillCalculatorFill } from "react-icons/bs";
import { BsBank } from "react-icons/bs";
import { GiMoneyStack } from "react-icons/gi";
import { TiArrowShuffle } from "react-icons/ti";
import { AiOutlineFileSearch } from "react-icons/ai";
import { IoIosLock } from "react-icons/io";
import { AiOutlineMenuUnfold } from "react-icons/ai";
import CartaCiaTerceroModal from './modalCartaCIATercero'
import { ImUpload } from "react-icons/im";
import SolicitudDescuentoModal from './modalSolicitudDescuento'
import TrazabilidadHitosModal from './modalTrazabilidadHitos'
import CierreGestionModal from './modalCierreGestion'
import CambiarTipoGestion from '../../cambiar-tipo-gestion'
import AntecedentesJudicialModal from './modalAntecedentesJudicial'
import GastosHonorariosModal from './modalGastosHonorarios'
import AntecedentesLegalesModal from './modalAntecedentesLegales'
import { TrazabilidadHitosComponent } from 'reccol-caso-general'

import { actualizarExtrajudicial, configuracionFormAction14, obtenerComboRegistrarHitos, obtenerDatosGestionImplicado, obtenerDatosGestionImplicadoDefault, obtenerListaImplicados} from '../../../store/actions/proceso-extrajudicial-action'
import { cambiarLoadingCarta, configuracionFormAction16, obtenerComboCompanias, obtenerComboMarcas, obtenerComboTipoVehiculos, obtenerDatosCartaCIATercero, obtenerMontos, obtenerParametroFecha } from '../../../store/actions/carta-cia-tercero-acttion'
import { cambiarLoadingGastos, configuracionFormAction22, obtenerComboCobertura, obtenerComboMonedas, obtenerComboTipoGasto } from '../../../store/actions/proceso-judicial-action'
import { obtenerSocitudDescuento } from '../../../store/actions/carta-cia-tercero-acttion'
import { configuracionFormAction17, obtenerCleanSolicitud, obtenerComboMotivoDescuento } from '../../../store/actions/solicitud-descuento-modal'
import { cambiarLoading, configuracionFormAction15, obtenerComboModoContactoModal, obtenerComboRespuestaContactoModal, obtenerDatosUltimoContacto, obtenerGrillaHistorial } from '../../../store/actions/contacto-tercero-action'
import { obtenerDatosGestion, obtenerDatosLlaves } from '../../../store/actions/recepciona-caso-action'
import Mensajes from '../../mensajes'

const useStyles = makeStyles((theme) => ({
  root: {
   height: 380,
    transform: 'translateZ(0px)',
    flexGrow: 1,
  },
  speedDial: {
    position: 'absolute',
    top: '-200px',
    right: '-60px',
    zIndex: '150',
    /* marginTop: '-250px', */
    /* right: theme.spacing(5), */
    
  },
  menu: {
    width: '50px',
    height: '50px',
    zIndex:250        
  },
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));
const useStylesToltip = makeStyles((theme) => ({
  tooltip: {
      fontSize: '12px',
      backgroundColor: 'black',
      color: 'white'
  }
}));

const AdministracionForm = ({setIsAmbito,isAmbito}) => {
  const [loading, setLoading]=useState(false)  
  const {esAbogado, rutUsuario, paisOrganizacion }=Auth.currentUser()
  const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
  const { cfg_form14, datosGestionImplicado, datosGestionImplicadoDefault, respuestaExtrajudicial, listaImplicados} = data_proceso_extrajudicial 
  const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
  const {llaves} = data_recepciona
  const data_solicitud_modal = useSelector((state) => state.solicitudDescuentoReducer)
  const { respuestaModalSolicitud } = data_solicitud_modal
   const [idCarpetaResExt, setIdCarpetaResExt] = useState('')
   const [fechaAudiencia, setFechaAudiencia] = useState("")
   const [fechaHitoContacto, setFechaOcurrencia] = useState("")
   const [codHitoContacto, setCodHitoContacto] = useState("")
   const [minutaHitoContacto, setMinutaHitoContacto] = useState("")
   const [showToast, setShowToast] = useState(true);
   const [show, setShow] = useState(false)
   const [showTraza, setShowTraza] = useState(false)
   const [showCierre, setShowCierre] = useState(false)
   const [showCambiarGestion, setShowCambiarGestion] = useState(false)
   const [showCIA, setShowCIA] = useState(false)
   const [showAJudicial, setShowAJudicial] = useState(false)
   const [showGastos, setShowGastos] = useState(false)
   const [showSolicitud, setShowSolicitud] = useState(false)
   const classes = useStyles();
   const classesTooltip = useStylesToltip();

  const [open, setOpen] = React.useState(false);
  const [hidden, setHidden] = React.useState(false);
  const [isRegistraHito, setIsRegistraHito] = React.useState(false);
  const [fechaSiniestro, setFechaSiniestro] = useState("")
  const [ambitoG, setAmbitoG] = useState("")
  const {state}=useLocation()
  const ambitoState=state?.row?.codAmbitoGestion ? state.row.codAmbitoGestion :232001
  const dispatch = useDispatch()

useEffect(() => {
  if(respuestaModalSolicitud &&respuestaModalSolicitud.respuestaModalSolicitud!==undefined && respuestaModalSolicitud.respuestaModalSolicitud["code"]===1){
   setTimeout(() => {
    handleCloseSolicitud()
   }, 2000); 
  }  
}, [respuestaModalSolicitud])

  useEffect(()=>{
    setAmbitoG(ambitoState)
  },[state])
  useEffect(() => {
    setIdCarpetaResExt(
      datosGestionImplicadoDefault &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] !== undefined &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] !== null &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt'] !== ''
        ? datosGestionImplicadoDefault.datosGestionImplicado[0]['idCarpetaResExt']
        : ''
    )
    setFechaAudiencia(
      datosGestionImplicadoDefault &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== undefined &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== null &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== ''
        ? convertirFecha(datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'])
        : ''
    )  
    setFechaSiniestro(
      datosGestionImplicadoDefault &&
      datosGestionImplicadoDefault.datosGestionImplicado[0]['fechaSiniestroFormat'] !== undefined &&
        datosGestionImplicadoDefault.datosGestionImplicado[0]['fechaSiniestroFormat'] !== null &&
        datosGestionImplicadoDefault.datosGestionImplicado[0]['fechaSiniestroFormat'] !== ''
        ? datosGestionImplicadoDefault.datosGestionImplicado[0]['fechaSiniestroFormat']
        : ''
    )   
   
   
  }, [datosGestionImplicadoDefault])
 
  const actions = [
    { icon: <IoIosLock  size={30} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-cierre']:'' ,id:'14_15'},
    { icon: <AiOutlineFileSearch  size={30} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-hitos' ]:'',id:'14_14'},
    //{ icon: <TiArrowShuffle  size={30} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-cambiotg']:'' ,id:'14_13'},
    { icon: <BsFillCalculatorFill  size={30} style={{color:'#00aeab'}}/>, name:cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-dcto']:'',id:'14_12' },
    { icon: <GiLetterBomb  size={40} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-carta']:'',id:'14_11' },
    { icon: <MdAccountBox  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-ctotro']:'', id:'14_10'} ,
   
  ];
  const actionsJudicial = [
    { icon: <IoIosLock  size={30} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-cierre']:'' , id:'14_15'},
    { icon: <AiOutlineFileSearch  size={30} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-hitos' ]:'', id:'14_14'},
    //{ icon: <TiArrowShuffle  size={30} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-cambiotg']:'' , id:'14_13'},
    { icon: <BsFillCalculatorFill  size={30} style={{color:'#00aeab'}}/>, name:cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-dcto']:'', id:'14_12' },
    { icon: <GiLetterBomb  size={40} style={{color:'#00aeab'}}/>, name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-carta']:'', id:'14_11' },
    {  icon: <GiMoneyStack  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form14 ? cfg_form14.cfg_form14['gestrecudirecto-menu-lateral-gastos']:'', id:'14_23'} ,
    //{  icon: <BsBank  size={30} style={{color:'#00aeab'}}/>,  name: cfg_form14 ? cfg_form14.cfg_form14['gestrecudirecto-menu-lateral-antecjud']:'', id:'14_22'} ,
    {  icon: <MdAccountBox  size={35} style={{color:'#00aeab'}}/>,  name: cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-menu-lateral-ctotro']:'', id:'14_10'} ,
   
  ];
  const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined){
      
      const [dia, mes, ano] = fecha?.split('-')
      const fechaFormat = [ano, mes, dia].join('-')
  
      return fechaFormat
    } else return null
  }
  const handleCloseToast = () => setShowToast(false)
  const handleCloseAJudicial = () => setShowAJudicial(false)
  const handleCloseGastos = () => setShowGastos(false)
  const handleCloseModal = () => setShow(false)
  const handleCloseCierre = () => setShowCierre(false)
  const handleCloseTraza = () => setShowTraza(false)
  const handleCloseCIA = () => setShowCIA(false)
  const handleCloseSolicitud = () => setShowSolicitud(false)
  const handleCloseTipoGestion= () => setShowCambiarGestion(false)

  const handleShowToast = () => setShowToast(true) 
  const handleShowAJudicial = () => setShowAJudicial(true) 
  const handleShowGastos = () => setShowGastos(true) 
  const handleShow = () => setShow(true) 
  const handleShowTraza = () => setShowTraza(true) 
  const handleShowTipoGestion = () => setShowCambiarGestion(true) 
  const handleOpen = () => { setOpen(true);};
  const handleShowCIA = () => setShowCIA(true) 
  const handleShowCierre = () => setShowCierre(true) 
  const handleShowSolicitud = () => setShowSolicitud(true) 

  const [implicadoSeleccionado, setImplicadoSeleccionado] = useState('')

  // Antecedentes Legales
  const [showAntecedentes, setShowAntecedentes] = useState(false);
  const handleCloseAntecedentes = () => { setShowAntecedentes(false) };
 

  const handleClose = () => {
    setOpen(false);
  };
  useEffect(()=>{
    if(llaves){
      let query = Buffer.from(
        JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": 0 })
      ).toString('base64')
      dispatch(obtenerDatosGestionImplicado(query))
    }   
  },[dispatch,llaves])

  useEffect(() => {
    if (llaves && cfg_form14 == null) {
      setLoading(true)
      let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves['idOrgCaso'], idCaso: llaves['idCaso'] })).toString('base64')
        dispatch(obtenerListaImplicados(query))
        .then(() => {
            let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": 0 })).toString('base64');
            dispatch(obtenerDatosGestionImplicadoDefault(query))
        }).then(() => {
            setLoading(false)
            setImplicadoSeleccionado(1);
            let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": 1 })).toString('base64')
            dispatch(obtenerDatosGestionImplicado(query))
        })
    }
  }, [dispatch, llaves, cfg_form14])
  
  useEffect(() => {
    if(datosGestionImplicadoDefault && llaves){
      setLoading(true)
      let query = Buffer.from(
        JSON.stringify({ "tipoGestion": datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]["codTipoGestion"], "ambitoGestion": datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]["codAmbitoGestion"],"idSituacion":215001,
        "idModoIngreso":238001
       })
      ).toString('base64')
      dispatch(obtenerComboRegistrarHitos(query))
      
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({ "rutcia": llaves && llaves["idOrgCaso"], idform: 14 })
        ).toString('base64')
        dispatch(configuracionFormAction14(query))
      })
      .then(()=>{
        
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
        ).toString('base64')
        dispatch(obtenerDatosUltimoContacto(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({idCaso:llaves && llaves["idCaso"], idImplicado: llaves && llaves["idImplicado"]})
        ).toString('base64')
        dispatch(obtenerDatosGestion(query))
      })
      .then(()=>{
        let query = Buffer.from(JSON.stringify({
          'rutcia': llaves && llaves['idOrgCaso'],
          'idform': 17
      })).toString('base64')
       dispatch(configuracionFormAction17(query))
      })
      .then(()=>setLoading(false))
    }
  }, [dispatch, datosGestionImplicadoDefault, llaves])  
  

  const handleAction = (action) => {
    if(action ==="14_10"){
      handleShow() 
      if (llaves && datosGestionImplicadoDefault) {
        dispatch(cambiarLoading(true))
          let query = Buffer.from(JSON.stringify({
              rutcia: llaves && llaves['idOrgCaso'],
              idform: 15
          })).toString('base64')
          dispatch(configuracionFormAction15(query))
      .then(()=>{
          let query = Buffer.from(
              JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
            ).toString('base64')
            dispatch(obtenerDatosUltimoContacto(query))
      })
      .then(()=>{
          let query = Buffer.from(JSON.stringify({
              idCaso: llaves && llaves["idCaso"],
              idImplicado: llaves && llaves["idImplicado"],
              idModoIngreso1: 238002,
              idModoIngreso2: 238003,
              tipoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codTipoGestion'],
              ambitoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codAmbitoGestion'],
              responsableReasignado: false
          })).toString('base64')
          dispatch(obtenerGrillaHistorial(query))
      })
      .then(()=>{
          let query = Buffer.from(JSON.stringify({
              tipoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codTipoGestion'],
              ambitoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codAmbitoGestion'],
              idModoIngreso: 238002
          })).toString('base64')
          dispatch(obtenerComboModoContactoModal(query))
      })
      .then(()=>{
          let query = Buffer.from(JSON.stringify({
              tipoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codTipoGestion'],
              ambitoGestion: datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codAmbitoGestion'],
              idModoIngreso: 238003
          })).toString('base64')
          dispatch(obtenerComboRespuestaContactoModal(query))
      })
      .then(()=>dispatch(cambiarLoading(false)))
  }
    } else if(action ==="14_11"){//Carta CIA
      
      if (llaves) {
        dispatch(cambiarLoadingCarta(true))
        let query = Buffer.from(JSON.stringify({
          "idImplicado": llaves && llaves['idImplicado'],
          "idCaso": llaves && llaves['idCaso']
        })).toString('base64')
        dispatch(obtenerDatosCartaCIATercero(query))
       .then(()=>{
         let query1 = Buffer.from(JSON.stringify({
           "idImplicado": llaves && llaves['idImplicado'],
           "idCaso": llaves && llaves['idCaso']
         })).toString('base64')
         dispatch(obtenerMontos(query1))
       })
       .then(()=>{
        let query = Buffer.from(JSON.stringify({"rutcia":0,"parametro":34})).toString('base64')
        dispatch(obtenerParametroFecha(query))
      })
       .then(()=>{
        let query = Buffer.from(JSON.stringify({
          rutcia: llaves && llaves['idOrgCaso'],
          idform: 16
      })).toString('base64')
       dispatch(configuracionFormAction16(query))
       })
       
       .then(()=>{
        let query = Buffer.from(JSON.stringify({})).toString('base64');
        dispatch(obtenerComboMarcas(query))
       })
       .then(()=>{
        let query = Buffer.from(JSON.stringify({"concepto": " 16"})).toString('base64');
        dispatch(obtenerComboTipoVehiculos(query))
       })
       .then(()=>{
        let query = Buffer.from(JSON.stringify({})).toString('base64');
        dispatch(obtenerComboCompanias(query))
       })
       .then(()=>{
        dispatch(cambiarLoadingCarta(false))
       })
      }
      handleShowCIA() 
    }else if(action ==="14_12"){//Solicitud Descuento
      if(respuestaModalSolicitud &&respuestaModalSolicitud.respuestaModalSolicitud!==undefined && respuestaModalSolicitud.respuestaModalSolicitud["code"]===1){
        dispatch(obtenerCleanSolicitud())
      }

      handleShowSolicitud() 
      if(llaves) { 

        let query2 = Buffer.from(JSON.stringify({
          "idImplicado": llaves && llaves['idImplicado'],
          "idCaso": llaves && llaves['idCaso']
      })).toString('base64')
      dispatch(obtenerMontos(query2))
      /*let query1 = Buffer.from(JSON.stringify({
        "idImplicado": llaves && llaves['idImplicado'],
        "idCaso": llaves && llaves['idCaso']
    })).toString('base64')
    dispatch(obtenerComboMotivoDescuento(query1))*/

        let query3 = Buffer.from(
          JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
        ).toString('base64')
        dispatch(obtenerSocitudDescuento(query3))

        let queryMotivo = Buffer.from(JSON.stringify({"concepto": " 239"})).toString('base64');
        dispatch(obtenerComboMotivoDescuento(queryMotivo));
      }
      let queryMotivo = Buffer.from(JSON.stringify({"concepto": " 239"})).toString('base64');
      dispatch(obtenerComboMotivoDescuento(queryMotivo));
      
    }
    else if(action ==='14_13'){//Cambio Gestión
     
      handleShowTipoGestion() 
    }
    else if(action ==='14_14'){//Traza Hitos
     
      handleShowTraza() 
    }
    else if(action ==='14_15'){//Cierre Gestión
     setLoading(true)
      handleShowCierre() 
      if(llaves){

        let query3 = Buffer.from(JSON.stringify({
          "idImplicado": llaves && llaves['idImplicado'],
          "idCaso": llaves && llaves['idCaso']
      })).toString('base64')
      dispatch(obtenerMontos(query3)).then(()=>setLoading(false))
      }
    }
    else if(action ==='14_22') {
      
      /*if (llaves && datosGestionImplicado){
        dispatch(cambiarLoadingJudicial(true))

        let query = Buffer.from(
          JSON.stringify({"idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"]})
        ).toString('base64')
        dispatch(obtenerAntecedentesJudiciales(query))
        .then(()=>{
          let query = Buffer.from(
            JSON.stringify({ "tipoGestion": datosGestionImplicado.datosGestionImplicado[0]["codTipoGestion"], "ambitoGestion": datosGestionImplicado.datosGestionImplicado[0]["codAmbitoGestion"],
              "idModoIngreso":238006
           })
          ).toString('base64')
          dispatch(obtenerComboHitoJudicial(query)) 
          
        })
        .then(()=>{
        let query = Buffer.from(
          JSON.stringify({"concepto":242
         })
        ).toString('base64')
        dispatch(obtenerComboLibros(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({ "concepto":240
         })
        ).toString('base64')
        dispatch(obtenerComboCompetencia(query))
      })
        .then(()=>{
          let query = Buffer.from(
            JSON.stringify({ "rutcia": llaves && llaves["idOrgCaso"], idform: 21})
          ).toString('base64')
          dispatch(configuracionFormAction21(query))
        })
        .then(()=>  dispatch(cambiarLoadingJudicial(false)))
      }
     
      handleShowAJudicial() */
      setShowAntecedentes(true);
    }
    else if(action ==='14_23'){//Provisión Gasto/Hono.
     if(llaves){
      dispatch(cambiarLoadingGastos(true))
      let query = Buffer.from(
        JSON.stringify({ "rutcia": llaves && llaves["idOrgCaso"], idform: 22})
      ).toString('base64')
      dispatch(configuracionFormAction22(query)).then(setLoading(false))
      .then(()=>{
        let query = Buffer.from(JSON.stringify({
          "idImplicado": llaves && llaves['idImplicado'],
          "idCaso": llaves && llaves['idCaso']
      })).toString('base64')
      dispatch(obtenerMontos(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({"concepto":244
         })
        ).toString('base64')
        dispatch(obtenerComboTipoGasto(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({"pais":paisOrganizacion, 'clasBien':datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]['codClasCaso']})
        ).toString('base64')
        dispatch(obtenerComboMonedas(query))
      })
      .then(()=>{
        let query = Buffer.from(
          JSON.stringify({"concepto":214  
         })
        ).toString('base64')
        dispatch(obtenerComboCobertura(query))
      })
    
      .then(()=> dispatch(cambiarLoadingGastos(false)))
     }
      handleShowGastos() 
    }
  };
  const recargarImplicados = () => {
    setLoading(true);
    let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves['idOrgCaso'], idCaso: llaves['idCaso'] })).toString('base64')
    dispatch(obtenerListaImplicados(query)).then(() => setLoading(false))
}
  const formik = useFormik({
    initialValues: {
      "idCaso":"",
      "idImplicadoCaso":"",
      "idOrganizacion":"",
      "idCarpetaResExt":"",
      "codTipoGestion": "",
      "codAmbitoGestion": "",
      "glosaAmbitoGestion": "",
      "codIntanciaGestion":"",
      "fechaAudiencia":"",
      "codHitoContacto":"", 
      "fechaHitoContacto":"",
      "minutaHitoContacto": "",
      "codHitoRespuesta": "",
      "fechaHitoRespuesta": "",
      "minutaHitoRespuesta": "",
      "recepciona": "",
      "aliasApp": "",
      "idUsuario":""
  

    },
    validationSchema: validationSchemas(isRegistraHito),
    onSubmit: (formData) => {
      setLoading(true)    
      const dataForm = { ...formData }      
      dataForm["idCaso"]=llaves && llaves["idCaso"]
      dataForm["idImplicadoCaso"]=llaves && llaves["idImplicado"]
      dataForm["idOrganizacion"]=llaves && llaves["idOrgCaso"]
      dataForm["idUsuario"]=llaves && llaves["idUsuario"]
      dataForm["codTipoGestion"]=datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]["codTipoGestion"]
      dataForm["codAmbitoGestion"]=datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0]["codAmbitoGestion"]
      dataForm["aliasApp"]="RECEPASICASO"
      dataForm["recepciona"]=0
     
      dispatch(actualizarExtrajudicial(dataForm)).then(()=>UpdateUltimoHito()).then(()=>setLoading(false))
      setCodHitoContacto('')
      setFechaOcurrencia('')
      setMinutaHitoContacto('')
    }
  })
  const UpdateUltimoHito=()=>{
    setLoading(true)
    if (llaves) {

      let query = Buffer.from(
        JSON.stringify({ "idCaso": llaves && llaves["idCaso"], "idImplicado": llaves && llaves["idImplicado"] })
      ).toString('base64')
      dispatch(obtenerDatosGestionImplicado(query)).then(()=>setLoading(false))
    }
  }
  const hoy = () => {
    const fecha = new Date()
    const hoy = fecha.toISOString().split('T')[0]
    return hoy
  }
  
  return (
    <>
 <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
    </style>
    <LoadingComponent show={loading}/>
    <Modal show={showCambiarGestion} onHide={setShowCambiarGestion} size='xl'>                
        <CambiarTipoGestion handleClose={handleCloseTipoGestion}/>                
    </Modal>    
    <Modal show={showTraza} onHide={handleCloseTraza} size='xl' >
      <TrazabilidadHitosComponent handleClose={handleCloseTraza} 
      idCaso={llaves && llaves['idCaso']}
      idImplicado={llaves && llaves['idImplicado']}
      idOrganizacionCaso={llaves && llaves['idOrgCaso']}
      />
    </Modal>
    <CartaCiaTerceroModal showCIA={showCIA} handleCloseCIA={handleCloseCIA}/>
    <ContactoTerceroModal show={show} handleCloseModal={handleCloseModal}/>
    <CierreGestionModal showCierre={showCierre} handleCloseCierre={handleCloseCierre}/>
    <AntecedentesJudicialModal showAJudicial={showAJudicial} handleCloseAJudicial={handleCloseAJudicial}/>
    <GastosHonorariosModal showGastos={showGastos} handleCloseGastos={handleCloseGastos}/>
    <SolicitudDescuentoModal showSolicitud={showSolicitud} handleCloseSolicitud={handleCloseSolicitud}/>
    <AntecedentesLegalesModal
        showAntecedentes={showAntecedentes}
        handleCloseAntecedentes={handleCloseAntecedentes}
    />
    <div className={classes.root}>
    
     
    {/* <Backdrop open={open}   /> */}
    <Form onSubmit={formik.handleSubmit}>
      <Container className='mb-4 mt-2 position-relative'>
        <SpeedDial
          ariaLabel="SpeedDial tooltip example"
          className={classes.speedDial}
          hidden={hidden}
          icon={<AiOutlineMenuUnfold size={30} />}
          onClose={handleClose}
          onOpen={handleOpen}
          open={true}
        
        >
          {ambitoG ===232001 ? (
            esAbogado ?
            actionsJudicial.map((action) => (
            <SpeedDialAction
              key={action.id}
              icon={action.icon}
              tooltipTitle={action.name}
              className={classes.menu}              
              onClick={()=>handleAction(action.id)}
              TooltipClasses={classesTooltip}                      
            />
          )): actionsJudicial.filter(f=>f.id!=='14_13').map((action) => (
            <SpeedDialAction
              key={action.id}
              icon={action.icon}
              tooltipTitle={action.name}
              className={classes.menu}              
              onClick={()=>handleAction(action.id)}
              TooltipClasses={classesTooltip}            
            />
          ))
          
          ):(
            esAbogado ?
            actionsJudicial.map((action) => (
            <SpeedDialAction
              key={action.id}
              icon={action.icon}
              tooltipTitle={action.name}
              className={classes.menu}              
              onClick={()=>handleAction(action.id)}
              TooltipClasses={classesTooltip}             
            />
          )):
          actionsJudicial.filter(f=>f.id!=='14_13').map((action) => (
            <SpeedDialAction
              key={action.id}
              icon={action.icon}
              tooltipTitle={action.name}
              className={classes.menu}              
              onClick={()=>handleAction(action.id)}
              TooltipClasses={classesTooltip}             
            />
          ))
          )}
        </SpeedDial>
      
        <Card className='mt-1 '>
          <Card.Header className='mt-0 mb-0' style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}>
            {cfg_form14 ? cfg_form14.cfg_form14['gestrecuextrajudicial-title-admcaso']: ''}
          </Card.Header>
          <Container>
            <Container>            
              {cfg_form14 ? (
                <div>                  
                  <Row>                 
                    <Col md="3">
                      <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form14.cfg_form14['gestrecuextrajudicial-input-carpetaresp']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Control
                        className='mt-2'
                        autoComplete='off'
                        value={
                          (formik.values.idCarpetaResExt =
                            idCarpetaResExt !== undefined && idCarpetaResExt)
                        }
                        onChange={(e) => {
                          formik.handleChange(e)
                          setIdCarpetaResExt(e.target.value)
                        }}
                        name='idCarpetaResExt'
                        error={formik.errors.idCarpetaResExt}
                      ></Form.Control>                     
                    </Col>
                    <Col md="3">
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form14.cfg_form14['gestrecuextrajudicial-lbl-ambitogest']}
                      </Form.Label>
                        <br />
                      <Form.Text className="mt-5">
                        {datosGestionImplicadoDefault &&
                          datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] !== undefined &&
                          datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] !== null &&
                          datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion'] !== ''
                          ? datosGestionImplicadoDefault.datosGestionImplicado[0]['ambitoGestion']
                          : ''}
                      </Form.Text>                     
                    </Col>
                    <Col md="3">
                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form14.cfg_form14['gestrecuextrajudicial-lbl-fechaaud']}
                        </Form.Label>
                        <br />
                        <Form.Text className="mt-5">
                            {datosGestionImplicadoDefault && datosGestionImplicadoDefault.datosGestionImplicado[0] &&
                                datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== undefined &&
                                datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== null &&
                                datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat'] !== ''
                                ? datosGestionImplicadoDefault.datosGestionImplicado[0]['fecAudienciaFormat']
                                : ''}
                        </Form.Text>
                    </Col>
                  </Row>
                  <hr style={{ color: '#04005D', height: '1px' }}></hr>
                  <Row> 
                    <Col md="5">
                      <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          Seleccione Implicado
                      </Form.Label>{' '}
                      <br />
                      <Form.Select
                          className='mt-2'
                          name='implicados'
                          onChange={(e) => {
                              formik.handleChange(e);
                              setImplicadoSeleccionado(e.target.value)
                              let impl = e.target.value !== "" ? e.target.value : 0;

                              //let query = { "idCaso": llaves['idCaso'], "idImplicado": impl, "idOrgCaso": llaves['idOrgCaso'], "idUsuario": rutUsuario }
                              //dispatch(obtenerDatosLlaves(query))
                              let query2 = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": impl })).toString('base64')
                              dispatch(obtenerDatosGestionImplicado(query2))
                          }}
                          value={implicadoSeleccionado}
                          >
                          <option value={''}>Seleccione...</option>
                          {listaImplicados &&
                              listaImplicados.listaImplicados?.map((c) => (
                                  <option key={c.IdImplicado} value={c.IdImplicado}>{c.NombreImplicadoCmb}</option>
                          ))}
                        </Form.Select>
                    </Col>
                    <Col md="1">
                        <Form.Label className='mb-0 mt-4' style={{ fontWeight: 'bold', fontSize: '14px', color: 'white' }}>-</Form.Label>{' '}<br />
                        <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>Recargar Implicados </Tooltip>}>
                            <Button type="button" style={{ float: 'left', backgroundColor: 'white', color: 'black' }} variant="outline-secondary" size="sm" onClick={() => recargarImplicados()}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                                </svg>
                            </Button>
                        </OverlayTrigger>
                    </Col>
                    <Col md="3">
                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form14.cfg_form14['gestrecuextrajudicial-lbl-ulthito']}
                        </Form.Label>
                        <br />
                        <Form.Text className="mt-5">
                            {datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] &&
                                datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== undefined &&
                                datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== null &&
                                datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== ''
                                ? datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso']
                                : ''}
                        </Form.Text>
                    </Col>
                    <Col md="3">
                        <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form14.cfg_form14['gestrecuextrajudicial-lbl-fechito']}
                        </Form.Label>
                        <br />
                        <Form.Text className="mt-5">
                            {datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0] &&
                                datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== undefined &&
                                datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== null &&
                                datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== ''
                                ? datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat']
                                : ''}
                        </Form.Text>
                    </Col>
                  </Row>                 

                  {/*<Row>                    
                    <Col md="4">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form14.cfg_form14[
                            'gestrecuextrajudicial-lbl-ultimohito'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className="mt-5">
                      {datosGestionImplicado &&
                        datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== undefined &&
                        datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== null &&
                        datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso'] !== ''
                        ? datosGestionImplicado.datosGestionImplicado[0]['ultimoHitoCaso']
                        : ''}
                    </Form.Text>                                         
                    </Col>
                    <Col md="2">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form14.cfg_form14[
                            'gestrecuextrajudicial-lbl-fechahito'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className="mt-5">
                        {datosGestionImplicado &&
                          datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== undefined &&
                          datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== null &&
                          datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat'] !== ''
                          ? datosGestionImplicado.datosGestionImplicado[0]['fechaUltimoHitoFormat']
                          : ''}
                      </Form.Text>                      
                    </Col>                    
                  </Row>*/}
                  
                 <Row className="mt-5">
                   <Col md="8"></Col>
                   <Col >
                      {respuestaExtrajudicial && 
                        <Mensajes
                            showToast={showToast}
                            handleCloseToast={handleCloseToast}
                            delay={5000}
                            responseData={respuestaExtrajudicial?.respuestaExtrajudicial}
                        ></Mensajes>
                      }
                   </Col>
                 </Row>
                  <hr style={{ color: '#04005D', height: '1px', marginTop:'20px' }}></hr>
                  <Acciones/>
                </div>
              ) : null}
            </Container>                 
          </Container>
        </Card>
      </Container>
     </Form>
     </div>
    </>
  )
}

export default AdministracionForm
